<template>
  <div>
    <MainHeader />
    <section class="py-40 min-h-screen">
      <div class="px-4 pb-12 max-w-screen-xl mx-auto">
        <div class="text-left">
          <h1 class="main-h1">
            <slot name="title" />
          </h1>

          <p class="mx-1 max-w-lg">
            <slot name="description" />
          </p>

          <SvgTitle />
        </div>
      </div>

      <slot />
    </section>
    <MainFooter />
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import MainFooter from '@/components/MainFooter'
import SvgTitle from '@/components/SvgTitle'

export default {
  components: { MainHeader, MainFooter, SvgTitle },
}
</script>
